export const AUTH_FROM_WISHLIST_DESKTOP = 'authFromWishlistDesktop';
export const AUTH_FROM_WISHLIST_MOBILE = 'AUTH_FROM_WISHLIST_MOBILE';
